import classNames from "classnames";
import React from "react";

export function NavbarBase(props: {
	children: React.ReactNode;
	is_fixed?: boolean;
}) {
	return (
		<>
			<nav
				className={classNames({
					"topnav--static": !props.is_fixed,
					topnav: props.is_fixed,
				})}
			>
				<div className="columns is-vcentered is-centered is-mobile">
					<div className="column is-11">
						<div className="columns is-vcentered is-mobile">
							<div className="column is-narrow">
								<a href="https://sesh.fyi">
									<img
										src={"/static/logo2transparent.png"}
										alt="Sesh Logo"
										className="header-logo"
									/>
								</a>
							</div>
							{props.children}
						</div>
					</div>
				</div>
			</nav>
			<div className="p-6"></div>
		</>
	);
}
